module.exports = __webpack_public_path__ + "static/media/nf.6860552f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/nf.svg
// module id = 208
// module chunks = 0